export const APP_STORE_URL = 'https://apps.apple.com/app/id6762517532';
export const ANDROID_DOWNLOAD_URL = 'https://catherine.oliverbinns.co.uk/wedding.apk';
